import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { installUnsavedFeedback } from '../utils/unsavedFeedback';
import './UnsavedFeedback.css';

export default function UnsavedFeedback() {
  const { pathname } = useLocation();
  const [saved, setSaved] = useState(false);
  useEffect(() => {
    const stop = installUnsavedFeedback(document);
    let timer;
    const showSaved = () => { setSaved(true); clearTimeout(timer); timer = setTimeout(() => setSaved(false), 1800); };
    window.addEventListener('cisa:saved-feedback', showSaved);
    return () => { stop(); clearTimeout(timer); setSaved(false); window.removeEventListener('cisa:saved-feedback', showSaved); };
  }, [pathname]);
  return saved ? <div className="saved-feedback-toast" role="status">✓ Salvato</div> : null;
}
